import { useContext } from "react"
import { Button } from "@headlessui/react"
import { SpeakerXMarkIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Mute() {
  const { muteAll, muteUnMute } = useContext(MultiContext)
  const onClick = ({ uuid }) => muteUnMute(uuid)

  return (
    <Panel>
      <Panel.Buttons>
        <Button
          onClick={muteAll}
          className="flex h-fit items-center gap-2 rounded-lg bg-gray-900/10 px-4 py-2 text-sm text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
        >
          <SpeakerXMarkIcon aria-hidden="true" className="-ml-0.5 size-5" />
          Mute all
        </Button>
      </Panel.Buttons>
      <Panel.Layout Icon={SpeakerXMarkIcon} onClick={onClick} />
    </Panel>
  )
}
